export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "v0.0.0-local";

export const FRONT_MATTER_TAG = "Career Climb Front Matter";

/* version up v7.5.1 */
/* trigger another client build */
/*
 * Pathway-preference recommendation bands. These are FRACTIONS of the maximum
 * preference score, so a raw score off the progress record must be divided by
 * PATHWAY_PREFERENCE_MAX_SCORE before it is compared against them.
 */
export const PATHWAY_PERSONALITY_HIGHLY_RECOMMENDED = 0.75;
export const PATHWAY_PERSONALITY_RECOMMENDED = 0.5;
export const PATHWAY_PERSONALITY_NON_LOSE = 0.25;

/**
 * Maximum pathway-preference score for one personality inventory. The inventory
 * normalises each pathway to this before submitting it, and the server stores
 * the raw value (`prg-<product>.pathwayPreferences`) without rescaling — so it
 * is the denominator that turns a stored score into a 0-1 fraction.
 */
export const PATHWAY_PREFERENCE_MAX_SCORE = 15;

// RIASEC score thresholds used on the back of the hat card to bucket a hat
// into "Great for" / "Tough for" RIASEC types, and reused by the hat-finder
// "High Interest" / "Low Interest" filter so all three views stay in sync.
export const RIASEC_HIGH_INTEREST_MIN_SCORE = 4.5;
export const RIASEC_LOW_INTEREST_MAX_SCORE = 3;
// Low-interest also requires a real (non-zero) score so unscored hats that
// default to 0 aren't pulled into the "Low Interest" bucket.
export const RIASEC_LOW_INTEREST_MIN_SCORE = 1;

export const CLEVER_LOGIN_METHOD = "Clever";
export const CLASSLINK_LOGIN_METHOD = "ClassLink";
export const BULK_LOGIN_METHOD = "LMS / SIS / Bulk CSV";
export const MANUAL_LOGIN_METHOD = "Manual";
export const NYC4D_LOGIN_METHOD = "nyc4d";
export const NYC4D_LOGIN_METHOD_DISPLAY = "NYC.ID";
export const GOOGLE_LOGIN_METHOD_DISPLAY = "Google";
export const HATS_AND_LADDERS_LOGIN_METHOD_DISPLAY = "Hats & Ladders";

// Shown on the disabled "Change Password" actions. Every login method except
// Hats & Ladders federates to an external IdP that owns the credential, so
// there is no password on our side to change.
export const SSO_PASSWORD_TOOLTIP =
  "This account uses Single Sign-On (SSO). Password updates must be managed directly through your SSO provider.";
